/**Модель описывает обновление комментария */
export class UpdateCommentModel {
  /**ID комментария */
  CommentId!: number;
  /**Текст комментария */
  Text!: string;

  constructor(obj?: Partial<UpdateCommentModel>) {
    Object.assign(this, obj);
  }
}
